import { createIcon } from './icon-utils';

export const DeleteTableRowsIcon = createIcon({
  path: 'm12.84 14.899.001.01a.75.75 0 0 1-.75.75h-1.75v4.25a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1 0-1.5h5.25v-3.5h-5.26a.742.742 0 0 1-.74-.75.75.75 0 0 1 .75-.75h7.75v-4.65h-7.75a.75.75 0 1 1 0-1.5h5.25v-3.35h-5.25a.75.75 0 1 1 0-1.5h6a.75.75 0 0 1 .75.75v4.1h1.577a.752.752 0 0 1 .923.73v6.16zm5.094-4.05 1.945-1.945a.75.75 0 0 1 1.06 1.06l-1.944 1.945 1.944 1.945a.75.75 0 0 1-1.06 1.06l-1.945-1.944-1.944 1.944a.75.75 0 0 1-1.061-1.06l1.944-1.945-1.944-1.945a.75.75 0 0 1 1.06-1.06l1.945 1.944z',
  viewBox: '0 0 24 24',
});
